import {goto} from '$app/navigation';

export async function protectRoute(currentUrl: URL, gotoUrl: URL, loggedIn: boolean) {

    const gotoRoute = gotoUrl.pathname

    if (loggedIn) {
        switch (gotoRoute) {
            case '/signin':
                await goto('/')
        }
    } else {
        // PROTECT ROUTES
        switch (gotoRoute) {
            case '/settings':
            case '/stats':
            case '/subscription':
            case '/testimonial':
            case '/next-feature':
            case '/custom-review':
                console.log('PROTECT ROUTE >> redirect')
                await goto('/signin', {state: {url: `${gotoUrl.href}`}})
        }
    }
}